module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Chapter one",
      "src": "images/ch01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Anime + Manga",
      "src": "images/ch01a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0001")]), _vm._v(" "), _c('strong', [_vm._v("Ryo of Wildfire: Character from Ronin Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Aaron Granofsky, FiberglassBlades, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" M-Squared Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0002")]), _vm._v(" "), _c('strong', [_vm._v("Speed Racer: Character from Speed Racer series")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Sean Patton, SMP Designs, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Bryan Humphrey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0003")]), _vm._v(" "), _c('strong', [_vm._v("Hikaru Ichijo: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Sean Patton, SMP Designs, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Bryan Humphrey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0004")]), _vm._v(" "), _c('strong', [_vm._v("Sakata Gintoki: Character from Gintama")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Athensis, Singapore; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kelvin Koh")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0005")]), _vm._v(" "), _c('strong', [_vm._v("Barnaby: Character from Tiger and Bunny")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eric Ng, BigWhiteBazooka, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Takaaa; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Takaaa; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" BigWhiteBazooka")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0006")]), _vm._v(" "), _c('strong', [_vm._v("Asuka Langley: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Pinky Lu Xun, Indonesia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Pinky Lu Xun; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Pinky Lu Xun; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Orochi X")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0007")]), _vm._v(" "), _c('strong', [_vm._v("Johannes Krauser II: Character from Detroit Metal City")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" David Haro; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0008")]), _vm._v(" "), _c('strong', [_vm._v("Victorique de Blois: Character from Gosick")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elena Samoylova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ekaterina Kruchinina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0009")]), _vm._v(" "), _c('strong', [_vm._v("Lina Inverse: Character from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Gladokova (Great Queen Lina), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taisia Flyagina (Tis)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0010")]), _vm._v(" "), _c('strong', [_vm._v("Sulfus: Character from Angel Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Janova Anna (Nikoli), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kido")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0011")]), _vm._v(" "), _c('strong', [_vm._v("Ho-Oh: Character from Pokémon (original Gijinka)")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Hickey, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lionel Lum")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0012")]), _vm._v(" "), _c('strong', [_vm._v("Villetta Nu: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Soni Balestier, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" P Karpey Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0013")]), _vm._v(" "), _c('strong', [_vm._v("Magician’s Valkyria: Character from Yu-Gi-Oh!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Telias, Argentina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sebastian Gambolati")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0014")]), _vm._v(" "), _c('strong', [_vm._v("Asuka Langley: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Pinky Lu Xun, Indonesia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Pinky Lu Xun; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Pinky Lu Xun; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Orochi X")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0015")]), _vm._v(" "), _c('strong', [_vm._v("Luffy Bulma: Character from Dragon Ball-Z")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megan Mobley, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jonathan Mendez Sr.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0016")]), _vm._v(" "), _c('strong', [_vm._v("Liepard: Character from Pokémon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Julia Brisette, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Torrence Neal")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0017")]), _vm._v(" "), _c('strong', [_vm._v("Eris: Character from Asobi ni Iku yo!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Imari Yumiki, American Cosplay Paradise, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Everon")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0018")]), _vm._v(" "), _c('strong', [_vm._v("Rio Otosuji: Character from Cherry Girls")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Monica Muñoz Orjuela, Columbia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Claudia Nino and Mdrica Muñoz; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Brunny Alejandra Veloza Garcia")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0019")]), _vm._v(" "), _c('strong', [_vm._v("Hatsume Miku: Character from Vocaloid")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Alina Vukelj, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lila Wong")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0020")]), _vm._v(" "), _c('strong', [_vm._v("Ichihara Yuuko: Character from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Katherine Tulina, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kseniya Luchkova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0021")]), _vm._v(" "), _c('strong', [_vm._v("Kaoru Kamiya: Character from Rurouni Kenshin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gingi Edmonds, Retrospective Imagery, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Gingi Edmonds and Jonathan Freeman; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Retrospective Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0022")]), _vm._v(" "), _c('strong', [_vm._v("The Kirin: Character from Pet Shop of Horrors")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Hickey, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ross Guida (Octomobiki)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0023")]), _vm._v(" "), _c('strong', [_vm._v("Kobato Hanato: Character from Kobato")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Kiselyova Tatiana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Bobyleva Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Belykova Irina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0024")]), _vm._v(" "), _c('strong', [_vm._v("Kobato Hanato: Character from Kobato")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nora Badacsonyi, Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andras Piroska")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0025")]), _vm._v(" "), _c('strong', [_vm._v("Kaoruko Someya: Character from Okane ga Nai")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Kiselyova Tatiana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Bobyleva Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Belykova Irina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0026")]), _vm._v(" "), _c('strong', [_vm._v("Inori Yuzuriha: Character from Guilty Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Imari Yumiki, American Cosplay Paradise, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Everon")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0027")]), _vm._v(" "), _c('strong', [_vm._v("Faye Valentine: Character from Cowboy Bebop")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gingi Edmonds, Retrospective Imagery, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Gingi Edmonds and Jonathan Freeman; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Retrospective Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0028")]), _vm._v(" "), _c('strong', [_vm._v("Lust: Character from Fullmetal Alchemist")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tracy Ho (Kiwi5Frog), Kiwi5Frog, Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Tracy Ho; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sojians")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0029")]), _vm._v(" "), _c('strong', [_vm._v("Judal: Character from Magi: The Labyrinth of Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Pamela Torres, Nazgwen Cosplay, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Teresa Macías; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verónica Santos (Dream Station)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0030")]), _vm._v(" "), _c('strong', [_vm._v("Stocking and Panty: Characters from Panty & Stocking with Garter Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christa J. Newman, Christa J. Newman Photography, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Breathlessaire and Starlighthoney; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Breathlessaire and Starlighthoney; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Christa J. Newman Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0031")]), _vm._v(" "), _c('strong', [_vm._v("Faye Valentine, Ed, Spike Spiegel, and Jet Black: Characters from Cowboy Bebop")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Jonathan Freeman, Retrospective Imagery, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Jonathan Freeman and Gingi Edmonds; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Jonathan Freeman, Gingi Edmonds, Jessica Edmonds, and Thomas Edmonds; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Retrospective Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0032")]), _vm._v(" "), _c('strong', [_vm._v("Kotone: Character from Pokémon Soul Silver/Heart Gold")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Chinako, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kyle")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land90"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0033")]), _vm._v(" "), _c('strong', [_vm._v("Sakura Hime: Character from Tsubasa Reservoir Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Telias, Argentina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sebastian Gambolati")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0034")]), _vm._v(" "), _c('strong', [_vm._v("Sakura: Character from Tsubasa Reservoir Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Carmen ma Lobato Cordón (Akari), Spain; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Rocío Borrego Fernández")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0035")]), _vm._v(" "), _c('strong', [_vm._v("HIZAKI: Character from Hizaki Grace Project")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Galinovskaya Anastasia (Kuroru), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0036")]), _vm._v(" "), _c('strong', [_vm._v("HIZAKI: Character from Versailles")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Galinovskaya Anastasia (Kuroru), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0037")]), _vm._v(" "), _c('strong', [_vm._v("Ciel Phantomhive: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Lunatique Touelle, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Cupcake")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0038")]), _vm._v(" "), _c('strong', [_vm._v("Shurei Hong: Character from Saiunkoku Monogatari")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Galinovskaya Anastasia (Kuroru), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0039")]), _vm._v(" "), _c('strong', [_vm._v("Michiru Kaioh: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Katherine Tulina, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kseniya Luchkova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0040")]), _vm._v(" "), _c('strong', [_vm._v("Lord of Nightmares: Character from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Gladkova (Great Queen Lina), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ralf (Musihin Sergey)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0041")]), _vm._v(" "), _c('strong', [_vm._v("Motonari Mori: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Alejandro Fernández; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0042")]), _vm._v(" "), _c('strong', [_vm._v("Ayagozen: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Andrea Parra; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0043")]), _vm._v(" "), _c('strong', [_vm._v("Hero: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Iván Parra; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0044")]), _vm._v(" "), _c('strong', [_vm._v("Akechi Mitsuhide: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" David Haro; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0045")]), _vm._v(" "), _c('strong', [_vm._v("Oda Nobunaga: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Guillermo Guevara; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0046")]), _vm._v(" "), _c('strong', [_vm._v("Oichi: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Ana Paulina Jiménez; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0047")]), _vm._v(" "), _c('strong', [_vm._v("Ginchiyo Tachibana: Character from Pokémon + Nobunaga’s Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tatiana Fernández; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0048")]), _vm._v(" "), _c('strong', [_vm._v("Battle Angel Alita: Character from Battle Angel Alita")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Riki LeCotey, Riddle’s Messy Wardrobe, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Pixelette")])]), _vm._v(" "), _c('div', {
    staticClass: "groupa"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0049")]), _vm._v(" "), _c('strong', [_vm._v("Sasuke Uchiha (Curse Seal Stage 2): Character from Naruto")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Brittany Hope, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ger Tysk")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0050")]), _vm._v(" "), _c('strong', [_vm._v("Hitsugaya Toshiro: Character from BLEACH")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Punkerdragon, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verrestelle")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0051")]), _vm._v(" "), _c('strong', [_vm._v("Rokura Unno: Character from Brave 10")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Micho Teh, Malaysia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Online tailor from Taobao; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Alfred XiaoLay; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Micho Teh")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0052")]), _vm._v(" "), _c('strong', [_vm._v("Olivier Mira Armstrong: Character from Fullmetal Alchemist")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0053")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko Amamiya: Character from Ef—A Tale of Melodies")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Mariya Karpenko (Fenix Fatalist), Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0054")]), _vm._v(" "), _c('strong', [_vm._v("Homura Akemi: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" The Booboo Shop; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0055")]), _vm._v(" "), _c('strong', [_vm._v("Rachel Alucard: Character from BlazBlue")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kochanova Elena (Lina Alucard), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Kochanova Lyudmila and Kochanova Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Kochanova Elena (Lina Alucard); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taras Buteiko")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0056")]), _vm._v(" "), _c('strong', [_vm._v("Kiri Komori: Character from Sayonara, Zetsubou-Sensei")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kochanova Elena (Lina Alucard), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Kochanova Lyudmila and Kochanova Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Kochanova Elena (Lina Alucard); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taras Buteiko")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0057")]), _vm._v(" "), _c('strong', [_vm._v("Re-L Mayer: Character from Ergo Proxy")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elle Blink, Elle Blink, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Chusova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kifir")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0058")]), _vm._v(" "), _c('strong', [_vm._v("Dead Master: Character from Black Rock Shooter")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elle Blink, Elle Blink, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Chusova and Elle Blink; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kifir")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0059")]), _vm._v(" "), _c('strong', [_vm._v("Monica Argento: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Isadora, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Karl Heinz Koch")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0060")]), _vm._v(" "), _c('strong', [_vm._v("Abel Nightroad: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Sylvie Kirkman, Little-Noise Photography, New Zealand; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Alexandra Pople; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Alexandra Pople; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sylvie Kirkman")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0061")]), _vm._v(" "), _c('strong', [_vm._v("Pacifica Casull: Character from Scrapped Princess")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Isadora, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Terra Surya Bakti")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0062")]), _vm._v(" "), _c('strong', [_vm._v("Edward Elric: Character from Fullmetal Alchemist")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Punkerdragon, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verrestelle")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0063")]), _vm._v(" "), _c('strong', [_vm._v("Aisha Clan Clan: Character from Outlaw Star")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Isadora, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ms. Katharina Mayer")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0064")]), _vm._v(" "), _c('strong', [_vm._v("Griffith: Character from Berserk")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Begoña Fernández Martín, UK; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Cheko")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0065")]), _vm._v(" "), _c('strong', [_vm._v("Fujimoto Shirou: Character from Blue Exorcist")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tania C (Wisecraxx), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" A. I. Shiteru Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0066")]), _vm._v(" "), _c('strong', [_vm._v("Sakura: Character from Tsubasa Reservoir Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Narcissa Evans, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Rachel Lewis")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0067")]), _vm._v(" "), _c('strong', [_vm._v("Kazama Chikage: Character from Hakuouki Shinsengumi Kitan")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Krylova Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Nadyozhina Tatiana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Belykova Irina")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0068")]), _vm._v(" "), _c('strong', [_vm._v("Lina Inverse: Character from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Gladkova (Great Queen Lina), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Maxim Chechenev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0069")]), _vm._v(" "), _c('strong', [_vm._v("Lina Inverse: Character from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Gladkova (Great Queen Lina), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Maxim Chechenev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0070")]), _vm._v(" "), _c('strong', [_vm._v("Sakura Hime: Character from Tsubasa Reservoir Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Telias, Argentina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sebastian Gambolati")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0071")]), _vm._v(" "), _c('strong', [_vm._v("Ion Fortuna: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eliot, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo Gomez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0031-06.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0072")]), _vm._v(" "), _c('strong', [_vm._v("Lina Inverse: Character from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Gladkova (Great Queen Lina), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexander Dubina (Alexander Sword)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0032-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0073")]), _vm._v(" "), _c('strong', [_vm._v("Yoko Littner: Character from Gurren Lagann")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eric Ng, BigWhiteBazooka, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" xStarcrown; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" xStarcrown; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" BigWhiteBazooka")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0074")]), _vm._v(" "), _c('strong', [_vm._v("Asuka Langley: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Jessica Jiang, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alton Sun")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0075")]), _vm._v(" "), _c('strong', [_vm._v("Yoko Littner: Character from Gurren Lagann")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Courtney Cook, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kenneth Davis")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0076")]), _vm._v(" "), _c('strong', [_vm._v("Saber Alter Maid: Character from Fate/Stay Night")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Emilie Gschweng, Koi-ishly, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Laurel Joly")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0077")]), _vm._v(" "), _c('strong', [_vm._v("Panty: Character from Panty & Stocking with Garter Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ani-Mia, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lars Peterson")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0078")]), _vm._v(" "), _c('strong', [_vm._v("Eliade: Character from D.Gray-Man")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" JustMoolti")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0079")]), _vm._v(" "), _c('strong', [_vm._v("Panty: Character from Panty & Stocking with Garter Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Borghini, Uruguay; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Pablo Hsieh and Mariana Sierra")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0034-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0080")]), _vm._v(" "), _c('strong', [_vm._v("Kuroneko (Cat Girl): Character from Trigun")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Miriam Peluso, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Miriam Peluso and Jason Peluso; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andreas Mortens")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0081")]), _vm._v(" "), _c('strong', [_vm._v("Edward Elric: Character from Fullmetal Alchemist")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Guillermo Guevara; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0082")]), _vm._v(" "), _c('strong', [_vm._v("Cornelia Vi Britannia: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Ana Paulina Jiménez; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0083")]), _vm._v(" "), _c('strong', [_vm._v("Saya Kisaragi: Character from Blood-C")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Ana Paulina Jiménez; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0084")]), _vm._v(" "), _c('strong', [_vm._v("Galaxy Untouchable: Character from Burst Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gothtea, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Chyenne Brundydge")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0085")]), _vm._v(" "), _c('strong', [_vm._v("Dark Chii: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megami Shiawase, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0086")]), _vm._v(" "), _c('strong', [_vm._v("CC: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Amy King, Ireland; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Nora Fox; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Amy King; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Stephen Hedley")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0036-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0087")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko Ichihara: Character from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Vickybunnyangel, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jack Liu")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0088")]), _vm._v(" "), _c('strong', [_vm._v("Fuu: Character from Naruto")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Heather McAffee (The Only Angel), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Holly Hillk")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0089")]), _vm._v(" "), _c('strong', [_vm._v("Habaek: Character from Bride of the Water God")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shuichi Shindou, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Shuichi Shindou and Glow; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Shuichi Shindou; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Your Pain")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0090")]), _vm._v(" "), _c('strong', [_vm._v("Kirin: Character from Pet Shop of Horrors")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Diana Tamarova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0091")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko Ichihara: Character from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Narcissa Evans, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Nicole Strojek")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0092")]), _vm._v(" "), _c('strong', [_vm._v("Nura: Character from Nura: Rise of the Yokai Clan")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Daniela Cristina Takahashi (Witchiko), Brazil; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anderson Luis Bonioli (And Yamasaki)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0038-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0093")]), _vm._v(" "), _c('strong', [_vm._v("Juvia Lockser: Character from Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kalyakina Daria")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0094")]), _vm._v(" "), _c('strong', [_vm._v("Perona: Character from One Piece")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Choi (AoiMizuno), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" SDraconis/Sanjay Vasandani")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0095")]), _vm._v(" "), _c('strong', [_vm._v("Doll: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Larchenko Veronika (Lady Integra), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anton Timofeev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0096")]), _vm._v(" "), _c('strong', [_vm._v("Naoto Fuyumine: Character from DOGS: Bullets and Carnage")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Darya Pasechnyk, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0097")]), _vm._v(" "), _c('strong', [_vm._v("Hatsune Miku: Character from Vocaloid")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Alina Vukelj, USA")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0098")]), _vm._v(" "), _c('strong', [_vm._v("Juvia Lockser: Character from Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Sarah Michell Ewell, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" M-Squared Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0099")]), _vm._v(" "), _c('strong', [_vm._v("Xerxes Break: Character from Pandora Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Yurlova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Natalia Yurlova and Matveeva Galina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Velery Kaptseva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0040-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0100")]), _vm._v(" "), _c('strong', [_vm._v("Sapphire Shadow Lady: Character from Shadow Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Begoña Fernández Martín, UK; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Emily Bastian")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0040-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0101")]), _vm._v(" "), _c('strong', [_vm._v("Articuno: Interpretation of a character from Pokémon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Monique Munoz, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Karen Santora")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0102")]), _vm._v(" "), _c('strong', [_vm._v("Ami Mizuno/Sailor Mercury: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Lexi Free, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Lilith Oya and Lexi Free; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Lexi Free; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Koneko Nunchaku")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0103")]), _vm._v(" "), _c('strong', [_vm._v("Adiane: Character from Gurren Lagann")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tanuki Tinka Asai, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Mel’Hiour")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0104")]), _vm._v(" "), _c('strong', [_vm._v("Kaoru Kozue: Character from Revolutionary Girl Utena")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Larchenko Veronika (Lady Integra), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anton Timofeev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0105")]), _vm._v(" "), _c('strong', [_vm._v("Bulma Bunny: Character from Dragonball Z")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Miriam Peluso, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Miriam Peluso; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Photoplasma")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0106")]), _vm._v(" "), _c('strong', [_vm._v("Juvia Lockser: Character from Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megan Fordham, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lionel Lum")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0107")]), _vm._v(" "), _c('strong', [_vm._v("Ciel Phantomhive: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Soboleva Elena, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Svetlana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Soboleva Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Shin")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0042-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0108")]), _vm._v(" "), _c('strong', [_vm._v("Chii: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elle Blink, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Chusova and Elle Blink; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kifir")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0109")]), _vm._v(" "), _c('strong', [_vm._v("Utena: Character from Revolutionary Girl Utena")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Katherine Tulina, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anton Timofeev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0110")]), _vm._v(" "), _c('strong', [_vm._v("Freya: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elle Blink, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Chusova and Elle Blink; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kifir")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0111")]), _vm._v(" "), _c('strong', [_vm._v("Mishima Reika: Character from Xephon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Janova Anna (Nikoli), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Shirayuki Team")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0112")]), _vm._v(" "), _c('strong', [_vm._v("Chii: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Melfina (Karen Ledford), Melfina Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Monique Blaizek")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0113")]), _vm._v(" "), _c('strong', [_vm._v("Madoka Kaname: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" SnowFall Slasher, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" SnowFall Slasher, Solenumira Concepcion, Ma Len Gases, and Keith Lorenzo; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" SnowFall Slasher; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Keith Lorenzo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0043-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0114")]), _vm._v(" "), _c('strong', [_vm._v("Madoka Kaname: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR/MODEL:")]), _vm._v(" Gerlina Christine (Kiko), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Neustroeva L.I. and Gerlina Christine (Kiko); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0044-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0115")]), _vm._v(" "), _c('strong', [_vm._v("Kadaj: Character from Final Fantasy VII Advent Children")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shuichi Shindou, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Shuichi Shindou and Shiki; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Your Pain")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0045-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0116")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko Ichihara: Character from Tsubasa Reservoir Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Denis Kitchatov")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0045-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0117")]), _vm._v(" "), _c('strong', [_vm._v("Death the Kid: Character from Soul Eater")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Felix, Death City Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Hyura A")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0045-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0118")]), _vm._v(" "), _c('strong', [_vm._v("Saeko Busujima: Character from High School of the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Carolina Gonzalez (Bastetsama), Argentina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Esteban Arias (Dinictis)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0045-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0119")]), _vm._v(" "), _c('strong', [_vm._v("Nico Robin: Character from One Piece")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Timofey Glushkov")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0045-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0120")]), _vm._v(" "), _c('strong', [_vm._v("Inu: Character from Togainu no Chi")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Soboleva Elena, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Svetlana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Soboleva Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Denis Kornilov")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0046-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0121")]), _vm._v(" "), _c('strong', [_vm._v("Alibaba and Cassim: Characters from Magi: The Labyrinth of Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tina Pham, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Tina Pham and Nancy Jang; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Tina Pham and Nancy Jang; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Raymond Fung")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0047-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0122")]), _vm._v(" "), _c('strong', [_vm._v("Kanzaki H. Aria: Character from Hidan no Aria")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Imel Aimeru")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0047-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0123")]), _vm._v(" "), _c('strong', [_vm._v("Erza Scarlet and Gray Fullbuster: Characters from A Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Anastasia Glushkova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Anastasia Glushkova and Timofey Glushkov; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Stanislav Em")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0047-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0124")]), _vm._v(" "), _c('strong', [_vm._v("Kokoa Shuzen: Character from Rosario Vampire: Season II")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kira Hokuten")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0047-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0125")]), _vm._v(" "), _c('strong', [_vm._v("Caroline and George: Characters from Paradise Kiss")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR/FABRICATOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Anastasia Glushkova and Timofey Glushkov; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Karina Gyulkhadzhan")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0126")]), _vm._v(" "), _c('strong', [_vm._v("Dilandau Albatou: Character from The Vision of Escaflowne")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Voroninskaya, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Emilia Golubeva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0127")]), _vm._v(" "), _c('strong', [_vm._v("Boris Airay: Character from Heart No Kuni No Alice")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megami Shiawase, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Nekudza")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0128")]), _vm._v(" "), _c('strong', [_vm._v("San: Character from Princess Mononoke")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Vickybunnyangel, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jack Liu")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0049-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0129")]), _vm._v(" "), _c('strong', [_vm._v("Klan Klang: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Leslie Rothstein, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Droo Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0049-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0130")]), _vm._v(" "), _c('strong', [_vm._v("Kai Hiwatari: Character from Beyblade")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Stephanie Beaulieu, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Droo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0050-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0131")]), _vm._v(" "), _c('strong', [_vm._v("Mytho: Character from Princess Tutu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" JustMoolti")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0051-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0132")]), _vm._v(" "), _c('strong', [_vm._v("Astharoshe Asran: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Vickybunnyangel, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jack Liu")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0051-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0133")]), _vm._v(" "), _c('strong', [_vm._v("Astharoshe Asran: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nora Badacsonyi, Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Csaba Födémesi")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0051-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0134")]), _vm._v(" "), _c('strong', [_vm._v("Marie Antoinette: Character from Lady Oscar")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Miriam Peluso, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ljinto")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0051-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0135")]), _vm._v(" "), _c('strong', [_vm._v("Le Louch Vi Britannia: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shuichi Shindou, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Shuichi Shindou and Shiki; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Your Pain")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0051-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0136")]), _vm._v(" "), _c('strong', [_vm._v("Astharoshe Asran and Esther Blanchett: Characters from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nora Badacsonyi, Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Nora Badacsonyi (Aoime) and Anett Bittner (Tazzie); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Csaba Födémesi")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0051-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0137")]), _vm._v(" "), _c('strong', [_vm._v("Esther Blanchett: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Larchenko Veronika (Lady Integra), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kseniya Luchkova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0052-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0138")]), _vm._v(" "), _c('strong', [_vm._v("Sakura: Character from Tsubasa Reservoir Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Narcissa Evans, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Rachel Lewis")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0052-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0139")]), _vm._v(" "), _c('strong', [_vm._v("Togame: Character from Katanagatari")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Reika Amakura, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Paulina Arnaldo; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kira Hokuten/Joseph Conrad Impazk")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0052-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0140")]), _vm._v(" "), _c('strong', [_vm._v("CC: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ryabkova Veronika (Kazuki Fuchouin), Belarusian State Music Theater, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alena Moreva (cxalena)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0052-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0141")]), _vm._v(" "), _c('strong', [_vm._v("Rei Ayanami: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" FedericaDN, Italy; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Michele Albrigo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0053-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0142")]), _vm._v(" "), _c('strong', [_vm._v("Sailor Neptune: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megami Shiawase, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Mad.Indigo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0053-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0143")]), _vm._v(" "), _c('strong', [_vm._v("Chii: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megami Shiawase, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Nekudza")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0053-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0144")]), _vm._v(" "), _c('strong', [_vm._v("Princess Neptune: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Melfina (Karen Ledford), Melfina Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marybeth Critz")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0054-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0145")]), _vm._v(" "), _c('strong', [_vm._v("Candy: Character from Candy Candy!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Bobyleva Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Bobyleva Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Belykova Irina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0146")]), _vm._v(" "), _c('strong', [_vm._v("Hetalia: Character from Axis Power")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elena Samoylova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ekaterina Kruchinina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0147")]), _vm._v(" "), _c('strong', [_vm._v("The Little Card: Character from Card Captors Sakura")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Hickey, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ross Guida (Octomobiki)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0148")]), _vm._v(" "), _c('strong', [_vm._v("Sailor Iron Mouse: Character from Sailor Moon: Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Hickey, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lionel Lum")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0149")]), _vm._v(" "), _c('strong', [_vm._v("Grell Sutcliff: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Akira")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0150")]), _vm._v(" "), _c('strong', [_vm._v("Celebi: Character from Pokémon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Hickey, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ross Guida (Octomobiki)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0055-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0151")]), _vm._v(" "), _c('strong', [_vm._v("Victorique de Blois: Character from Gosick")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elena Samoylova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ekaterina Kruchinina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0056-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0152")]), _vm._v(" "), _c('strong', [_vm._v("CC: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ryabkova Veronika (Kazuki Fuchouin), Belarusian State Music Theater, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alena Moreva (cxalena)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0153")]), _vm._v(" "), _c('strong', [_vm._v("Ranka Lee: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Janova Anna (Nikoli), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Yui Lang")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0154")]), _vm._v(" "), _c('strong', [_vm._v("CC and Zero: Characters from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Santana Maynard, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Santana Maynard and Doug Smith; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Flutter-Tee Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0155")]), _vm._v(" "), _c('strong', [_vm._v("Michiru Kaioh/Sailor Neptune: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR/MODEL:")]), _vm._v(" Ran Fujimiya (SeminaVarvara), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0156")]), _vm._v(" "), _c('strong', [_vm._v("Hades: Character from Olimpos")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nicole Strojek, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Rachel Lewis")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0157")]), _vm._v(" "), _c('strong', [_vm._v("CC: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ryabkova Veronika (Kazuki Fuchouin), Belarusian State Music Theater, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Aleksandra Kaminskay (Akami)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0057-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0158")]), _vm._v(" "), _c('strong', [_vm._v("CC: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anette Bittner (Tazzie), Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Gergely Piroska")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0058-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0159")]), _vm._v(" "), _c('strong', [_vm._v("Sakura: Character from Tsubasa Reservoir Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Chrome-sensei, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Kyo and Chrome-sensei; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Chrome-sensei; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0058-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0160")]), _vm._v(" "), _c('strong', [_vm._v("Euphemia li Britannia: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Melfina (Karen Ledford), Melfina Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marybeth Critz")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0161")]), _vm._v(" "), _c('strong', [_vm._v("Sakura: Character from Tsubasa Reservoir Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Chrome-sensei, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Rei, Kyo, Vasya, Chrome-sensei and Zil; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0162")]), _vm._v(" "), _c('strong', [_vm._v("End Breaker!: Character from End Breaker!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ferny Andrade, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo Gomez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0163")]), _vm._v(" "), _c('strong', [_vm._v("Lelouch vi Britannia: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Alina Vukelj, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zhanyi Jiang")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0164")]), _vm._v(" "), _c('strong', [_vm._v("Princess Kakyuu: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nora Badacsonyi, Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Csaba Födémesi")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0165")]), _vm._v(" "), _c('strong', [_vm._v("Madoka Kaname Goddess: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gerlina Christine (Kiko), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Neustroeva L.I. and Gerlina Christine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Gerlina Christine (Kiko); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0166")]), _vm._v(" "), _c('strong', [_vm._v("Grell Sutcliff: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Asako@Aso")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0060-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0167")]), _vm._v(" "), _c('strong', [_vm._v("Senji Kiyomasa: Character from Deadman Wonderland")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Alexander Stolyarov; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Alexander Stolyarov; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Belykova Irina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_61"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0061-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0168")]), _vm._v(" "), _c('strong', [_vm._v("Shadow Naoto: Character from SMT: Persona 4")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" celsius, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Frankel Huang")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0061-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0169")]), _vm._v(" "), _c('strong', [_vm._v("Sera Victoria: Character from Hellsing Ultimate")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Haley Holmes, HNH Beauty, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Greg Edwards")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0061-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0170")]), _vm._v(" "), _c('strong', [_vm._v("Naruto Uzumaki: Character from Naruto Shippuden")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Stephanie Beaulieu, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Chiliem Le")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0061-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0171")]), _vm._v(" "), _c('strong', [_vm._v("Blair: Character from Soul Eater")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Miriam Peluso, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Photoplasma")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0061-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0172")]), _vm._v(" "), _c('strong', [_vm._v("Kakashi Hatake: Character from Naruto")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Paul Kulowitch, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Larry Irvin Hullum, Jr.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0061-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0173")]), _vm._v(" "), _c('strong', [_vm._v("Sebastian Michaelis: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Martin Chella, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo So")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_62"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0062-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0174")]), _vm._v(" "), _c('strong', [_vm._v("Esther Blanchett: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Maria Avdonyushkina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexanov Alexey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_63"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0063-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0175")]), _vm._v(" "), _c('strong', [_vm._v("Serenity: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Carmen ma Lobato Cordón (Akari), Spain; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Virginia Polo Gonzalez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0063-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0176")]), _vm._v(" "), _c('strong', [_vm._v("Caterina Sforza: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" The Booboo Shop; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0063-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0177")]), _vm._v(" "), _c('strong', [_vm._v("Kamui Shirou: Character from X1999")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ryabkova Veronika (Kazuki Fuchouin), Belarusian State Music Theater, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alex Marchenko")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0063-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0178")]), _vm._v(" "), _c('strong', [_vm._v("Mononoke Hime: Character from Princess Mononoke")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Darya Pasechnyk, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Pugoffka")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0063-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0179")]), _vm._v(" "), _c('strong', [_vm._v("Sheryl Nome: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belyaeva Elena (Serenity), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Tatiana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Belyaeva Elena (Serenity); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexander")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0063-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0180")]), _vm._v(" "), _c('strong', [_vm._v("Adiane: Character from Gurren Lagann")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Darya Pasechnyk, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land85"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_64"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0064-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0181")]), _vm._v(" "), _c('strong', [_vm._v("Sakata Gintoki: Character from Gin Tama")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Athensis, Singapore; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Nik Yan")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0064-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0182")]), _vm._v(" "), _c('strong', [_vm._v("Kenshin Himura: Character from Rurouni Kenshin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Stephanie Beaulieu, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Droo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0064-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0183")]), _vm._v(" "), _c('strong', [_vm._v("Ayanami Rei: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megami Shiawase, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Megamie Shiawase, mask by Anna Tsypriyan; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_65"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0065-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0184")]), _vm._v(" "), _c('strong', [_vm._v("Megumi: Character from Rurouni Kenshin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Riko Kojima, Malaysia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Raz Hoe")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0065-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0185")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko Ichihara: Character from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andrey Sukhanov")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0065-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0186")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko Ichihara and Watanuki Kimihiro: Characters from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Anastasia Glushkova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Anastasia Glushkova and Pavel Gryaznov; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Mikhail Girshovich")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_66"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0066-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0187")]), _vm._v(" "), _c('strong', [_vm._v("Shana: Character from Shakugan no Shana")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Diana de Mol, The Netherlands; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Janna de Mol")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0066-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0188")]), _vm._v(" "), _c('strong', [_vm._v("Maria Magdalena: Character from D.Gray-Man")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Diana de Mol, The Netherlands; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Janna de Mol")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0066-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0189")]), _vm._v(" "), _c('strong', [_vm._v("Grell Sutcliff: Character from Kuroshitsuji Musical II")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Dmitry Bagdasarian")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0066-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0190")]), _vm._v(" "), _c('strong', [_vm._v("Grell Sutcliff: Character from Kuroshitsuji Musical I")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Gvo3D")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0066-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0191")]), _vm._v(" "), _c('strong', [_vm._v("Asuka Langley (Maid Figure): Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Laura Benson (Lolain Progress), Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" fiathriel (Rachel Lewis)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_67"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0067-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0192")]), _vm._v(" "), _c('strong', [_vm._v("Angelina: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Pykhteeva Natalia Petrovna, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Tarasova Vera")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0067-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0193")]), _vm._v(" "), _c('strong', [_vm._v("Chrona: Character from Soul Eater")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Shua; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Shua; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Gvo3D")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0067-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0194")]), _vm._v(" "), _c('strong', [_vm._v("Sheryl Nome: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Laura Benson (Lolain Progress), Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" fiathriel (Rachel Lewis)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0067-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0195")]), _vm._v(" "), _c('strong', [_vm._v("Madame Red: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Heather Holdren, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Falling Feathers")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_68"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0068-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0196")]), _vm._v(" "), _c('strong', [_vm._v("Chii: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" GunKatCosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Dana Rutowski")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0068-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0197")]), _vm._v(" "), _c('strong', [_vm._v("Princess Tutu and Princess Kraehe: Characters from Princess Tutu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shauna Leva, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Shauna Leva; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Shauna Leva and Alison Landolt; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Laura Scannell")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0068-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0198")]), _vm._v(" "), _c('strong', [_vm._v("Rei Ayanami: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Hyura Ai, Death City Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Felix (Death City Cosplay)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0068-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0199")]), _vm._v(" "), _c('strong', [_vm._v("Kirara: Character from Zone00")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eric Ng, BigWhiteBazooka, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Mingswly; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Mingswly; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" BigWhiteBazooka")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_69"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0069-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0200")]), _vm._v(" "), _c('strong', [_vm._v("Princess Tutu: Character from Princess Tutu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Leigh A. Alexander, The Prancing Unicorn, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Tim Mahaven of DeathCom.NET")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0069-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0201")]), _vm._v(" "), _c('strong', [_vm._v("Ahiru: Character from Princess Tutu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Valentina Bruni, Italy; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alessandro Casini")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_70"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0070-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0202")]), _vm._v(" "), _c('strong', [_vm._v("Tomoe Mami: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Reika Amakura, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Rosario Tolentino and Paulina Arnaldo; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Z3II Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_71"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0071-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0203")]), _vm._v(" "), _c('strong', [_vm._v("Rachel Alucard: Character from BlazBlue")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR/MODEL:")]), _vm._v(" Kochanova Elena (Lina Alucard), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Kochanova Lyudmila and Kochanova Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taras Buteiko")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0071-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0204")]), _vm._v(" "), _c('strong', [_vm._v("Yoko Littner: Character from Gurren Lagann")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Victoria Kicha, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ashley Badie")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0071-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0205")]), _vm._v(" "), _c('strong', [_vm._v("Dawn: Character from Pokémon Diamond and Pearl")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Choi (AoiMizuno), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sojians")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0071-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0206")]), _vm._v(" "), _c('strong', [_vm._v("Rei Miyamoto: Character from High School of the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eric Ng, BigWhiteBazooka, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" The Sushi Monster; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" The Sushi Monster; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" BigWhiteBazooka")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0071-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0207")]), _vm._v(" "), _c('strong', [_vm._v("Sailor Saturn: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Chinako, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kyle")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0071-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0208")]), _vm._v(" "), _c('strong', [_vm._v("Bonten and Shinonome Kon: Characters from Amatsuki")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ven & Dark, Deep Dive Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Ven & Dark; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Ven & Dark; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" jellybeantotoro")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_72"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0072-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0209")]), _vm._v(" "), _c('strong', [_vm._v("Amelia: Character from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Janova Anna (Nikoli), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Rem")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_73"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0073-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0210")]), _vm._v(" "), _c('strong', [_vm._v("Kagehisa Anotsu: Character from Blade Immortal")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Begoña Fernández Martín, UK; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Aran")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0073-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0211")]), _vm._v(" "), _c('strong', [_vm._v("Kenshin and Tomoe: Characters from Rurouni Kenshin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eric Ng, BigWhiteBazooka, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR/MODELS:")]), _vm._v(" Dasutin26 and Barbaroo; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" BigWhiteBazooka")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0073-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0212")]), _vm._v(" "), _c('strong', [_vm._v("Miyu: Character from Vampire Princess Miyu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" FedericaDN, Italy; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Luca Albrigo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0073-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0213")]), _vm._v(" "), _c('strong', [_vm._v("Rei Ayanami: Character from Neon Genesis Evangelion")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Amy King, Ireland; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Nora Fox; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Amy King; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" David Kennedy Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0073-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0214")]), _vm._v(" "), _c('strong', [_vm._v("Sanosuke Sagara: Character from Rurouni Kenshin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gingi Edmonds, Retrospective Imagery, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Sean Hopper, Gingi Edmonds, and Jonathan Freeman; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Sean Hopper; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Retrospective Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_74"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0074-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0215")]), _vm._v(" "), _c('strong', [_vm._v("Gyula Kádár: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Voroninskaya, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ekaterina Zaharova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0074-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0216")]), _vm._v(" "), _c('strong', [_vm._v("Seth Nightlord: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Voroninskaya, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Oleg Kugaev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_75"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0075-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0217")]), _vm._v(" "), _c('strong', [_vm._v("Franz d’Epinay: Character from Gankutsuou: The Count of Monte Cristo")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Tsyplenkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexanov Alexey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0075-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0218")]), _vm._v(" "), _c('strong', [_vm._v("Xecty Ein: Character from Shining Tears x Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belyaeva Elena (Serenity), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" ChooPEACE")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0075-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0219")]), _vm._v(" "), _c('strong', [_vm._v("Sesita 00/Chiester 00: Character from Umineko no Naku Koro ni")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Laura Benson (Lola In Progress), Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jin Liu (Panda Photography)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0075-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0220")]), _vm._v(" "), _c('strong', [_vm._v("Abel Nightroad: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tania C (Wisecraxx), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eurobeat King")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0075-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0221")]), _vm._v(" "), _c('strong', [_vm._v("Sakura and Shaoran: Characters from Tsubasa Reservoir Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ven & Dark, Deep Dive Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Ven & Dark; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Ven & Dark; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Spleenie")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_76"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0076-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0222")]), _vm._v(" "), _c('strong', [_vm._v("America: Character from Hetalia")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Punkerdragon, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verrestelle")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0076-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0223")]), _vm._v(" "), _c('strong', [_vm._v("Faye Valentine: Character from Cowboy Bebop")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Darya Pasechnyk, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0076-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0224")]), _vm._v(" "), _c('strong', [_vm._v("Mikazuki Yozora: Character from Boku wa Tomodachi ga Sukunai")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jene Kirishima")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0076-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0225")]), _vm._v(" "), _c('strong', [_vm._v("Tomoe Mami: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Hane-Wa Cosplay, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jason Shum")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0076-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0226")]), _vm._v(" "), _c('strong', [_vm._v("Haruhi Suzumiya: Character from The Melancholy of Haruhi Suzumiya")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Punkerdragon, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verrestelle")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0076-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0227")]), _vm._v(" "), _c('strong', [_vm._v("Tohru Honda and Yuki Sohma: Characters from Fruits Basket")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gingi Edmonds, Retrospective Imagery, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS/MODELS:")]), _vm._v(" Gingi Edmonds and Jonathan Freeman; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Retrospective Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_77"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0077-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0228")]), _vm._v(" "), _c('strong', [_vm._v("Videl: Character from Dragonball Z")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Redei (Enji Night), Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Balázs Sármai")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0077-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0229")]), _vm._v(" "), _c('strong', [_vm._v("Holo: Character from Spice and Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Santana Maynard, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kashiitan")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_78"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0078-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0230")]), _vm._v(" "), _c('strong', [_vm._v("Lelouch Vi Britannia: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR/MODEL:")]), _vm._v(" Stephanie Beaulieu, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Celeste Farias, Sweet Tifa, Zeiven, and Stephanie Beaulieu; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Liquid Cocaine Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0078-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0231")]), _vm._v(" "), _c('strong', [_vm._v("Clovis La Britannia: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Novoselov Aleksandr, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Xenia Aranta; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Novoselov Aleksandr; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Tis")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0078-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0232")]), _vm._v(" "), _c('strong', [_vm._v("Ion Fortuna: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anton Timofeev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0078-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0233")]), _vm._v(" "), _c('strong', [_vm._v("Sister Esther Blanchett: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Melfina (Karen Ledford), Melfina Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Monique Blaize")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0078-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0234")]), _vm._v(" "), _c('strong', [_vm._v("Akira Ferrari and Alicia Florence: Characters from Aria")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Michele Albrigo, Italy; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Barbara Furlan and Gabriella Morocchio; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Michele Albrigo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0078-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0235")]), _vm._v(" "), _c('strong', [_vm._v("Kendappa-Ou: Character from Rg Veda")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Lunatique Touelle, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Melissa Tran")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_79"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0079-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0236")]), _vm._v(" "), _c('strong', [_vm._v("Ion Fortuna: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" JustMoolti")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_80"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0080-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0237")]), _vm._v(" "), _c('strong', [_vm._v("Cibo: Character from Blame!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tanuki Tinka Asai, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" N†kon")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0080-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0238")]), _vm._v(" "), _c('strong', [_vm._v("Cibo: Character from Blame!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nicole Strojek, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelo Beltran")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0080-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0239")]), _vm._v(" "), _c('strong', [_vm._v("Sheryl Nome: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Nicole Strojek, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andy Wana")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0080-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0240")]), _vm._v(" "), _c('strong', [_vm._v("Akemi Homura: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zhelle Sancho")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0080-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0241")]), _vm._v(" "), _c('strong', [_vm._v("The Fight: Character from Card Captor Sakura")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Julie Rich, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Jamie Rich; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Jamie Rich; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Julie Rich")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0080-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0242")]), _vm._v(" "), _c('strong', [_vm._v("Myoubi: Character from Alichino")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Daniela Cristina Takahashi (Witchiko), Brazil; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anderson Luis Bonioli (And Yamasaki)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_81"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0081-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0243")]), _vm._v(" "), _c('strong', [_vm._v("Meifon Li: Character from Angel Links")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Isadora, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ms. Katharina Mayer")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0081-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0244")]), _vm._v(" "), _c('strong', [_vm._v("Fatima Machi: Character from Five Star Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Galinovskaya Anastasia (Kuroru), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0081-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0245")]), _vm._v(" "), _c('strong', [_vm._v("Sayaka Yumi: Character from Mazinger Z")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elisabetta Tosi/Lilletta, Italy; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" mondocosplay.it")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_82"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0246")]), _vm._v(" "), _c('strong', [_vm._v("Horo: Character from Spice and Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Leslie Rothstein, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Droo Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0247")]), _vm._v(" "), _c('strong', [_vm._v("Eudial: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kiriko Anchar, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Mila Fedotova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0248")]), _vm._v(" "), _c('strong', [_vm._v("Beatrice: Character from Umineko no Naku Koro ni")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" The Booboo Shop; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0249")]), _vm._v(" "), _c('strong', [_vm._v("Madam Red: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Andrea Stames, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Cliff Nordman")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0250")]), _vm._v(" "), _c('strong', [_vm._v("Vash the Stampede: Character from Trigun")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Jazmyn Douillard, FireLight Gleam Illustrations, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Consplayers")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0251")]), _vm._v(" "), _c('strong', [_vm._v("Rachel Alucard: Character from BlazBlue")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Mariya Karpenko (Fenix Fatalist), Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_83"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0083-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0252")]), _vm._v(" "), _c('strong', [_vm._v("Utena Tenjou: Character from the Adolescence of Utena")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Mariya Karpenko (Fenix Fatalist), Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0083-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0253")]), _vm._v(" "), _c('strong', [_vm._v("Klan Klan: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Riko Kojima, Malaysia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Raz Hoe")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_84"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0084-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0254")]), _vm._v(" "), _c('strong', [_vm._v("Ciel Phantomhive: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eliot, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo Gomez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0084-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0255")]), _vm._v(" "), _c('strong', [_vm._v("Ciel Phantomhive: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Luna Selenium, Spain; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jose Manchado")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0084-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0256")]), _vm._v(" "), _c('strong', [_vm._v("Alfred F. Jones and Arthur Kirkland: Characters from Hetalia")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ven & Dark, Deep Dive Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Ven & Dark; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Ven & Dark; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" SerenadeStrong")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0084-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0257")]), _vm._v(" "), _c('strong', [_vm._v("Emeraldas: Character from Queen Emeraldas")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belykova Irina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Provotorova Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Provotorova Natalia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Belykova Irina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_85"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0085-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0258")]), _vm._v(" "), _c('strong', [_vm._v("Erniuth dai gu Fillmore V: Character from the Five Star Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ilina Daria, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0085-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0259")]), _vm._v(" "), _c('strong', [_vm._v("Captain Mary Spencer: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Arras M. Wiedorn, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kristiina Korpus")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0085-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0260")]), _vm._v(" "), _c('strong', [_vm._v("Sebastian Michaelis: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kristina Mickel, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Kristina Mickel and Danielle Paladino; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Bryan Humphries")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0085-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0261")]), _vm._v(" "), _c('strong', [_vm._v("Ciel Phantomhive: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Galinovskaya Anastasia (Kuroru), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_86"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0086-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0262")]), _vm._v(" "), _c('strong', [_vm._v("Astaroth: Character from Angel Sanctuary")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kiriko Anchar, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Oleg Tegatti")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0086-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0263")]), _vm._v(" "), _c('strong', [_vm._v("Victoria Seras: Character from Hellsing OVA")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Celuyko (Pixie), Panda Banda, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0086-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0264")]), _vm._v(" "), _c('strong', [_vm._v("Dinah Wherever: Character from Bizenghast")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Chepsarakova Anna (Leyana), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Chepsarakova Anna (Leyana) and Angelina Goncharova (Ashitaro); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Chepsarakova Anna (Leyana); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0086-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0265")]), _vm._v(" "), _c('strong', [_vm._v("Larmica Lee: Character from Vampire Hunter D")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Shua, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Dmitry Bagdasarian")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_87"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0087-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0266")]), _vm._v(" "), _c('strong', [_vm._v("Areshu: Character from Six Apostles of Ruina")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Francisco Pelayo (NeonLights), NeonLights Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo Gomez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0087-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0267")]), _vm._v(" "), _c('strong', [_vm._v("Lilith Sahl: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Maria Avdonyushkina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Askar Ibragimov")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0087-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0268")]), _vm._v(" "), _c('strong', [_vm._v("Alone Hades: Character from Saint Seiya: The Lost Canvas")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Pamela Torres, Nazgwen Cosplay, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Teresa Macías; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verónica Santos (Dream Station)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_88"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0088-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0269")]), _vm._v(" "), _c('strong', [_vm._v("Abel Nightroad: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Tsyplenkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexanov Alexey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0088-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0270")]), _vm._v(" "), _c('strong', [_vm._v("Solf J. Kimblee: Character from Fullmetal Alchemist")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Mary Cua; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0088-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0271")]), _vm._v(" "), _c('strong', [_vm._v("Amelia Wil Tesla Seyruun and Zelgadis: Characters from Slayers")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Mike Kowalek, eleventhphotograph, Canada, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Andrée Warner and Michele Warner; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Andrée Warner and Michele Warner; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" eleventhphotograph")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0088-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0272")]), _vm._v(" "), _c('strong', [_vm._v("Negi Springfield: Character from Mahou Sensei Negima")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Daniela Cristina Takahashi (Witchiko), Brazil; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Anderson Luis Bonioli (And Yamasaki)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_89"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0089-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0273")]), _vm._v(" "), _c('strong', [_vm._v("Kingdra: Character from Pokémon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ronald Wolf, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Claudia Franz and Ronald Wolf; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andreas Zimmer")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0089-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0274")]), _vm._v(" "), _c('strong', [_vm._v("Fernando Arias as himself in Gantz: Original character inspired by Gantz")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Paulina Jiménez, Peru; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Fernando Arias; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Marlina Sánchez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0089-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0275")]), _vm._v(" "), _c('strong', [_vm._v("Xanxus: Character from Hitman Reborn")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Evgeniy Machihin (Indie), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Valery Belova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Aleksandra Kaminskaya (Akami)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_90"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0090-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0276")]), _vm._v(" "), _c('strong', [_vm._v("Szayel Aporro Granz: Character from BLEACH")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Luna Selenium, Spain; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jose Manchado")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0090-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0277")]), _vm._v(" "), _c('strong', [_vm._v("Sheryl Nome: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Stephanie Beaulieu, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Celeste Farias; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Chiliem Le")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0090-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0278")]), _vm._v(" "), _c('strong', [_vm._v("Sheryl Nome: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belyaeva Elena (Serenity), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Tatiana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Belyaeva Elena (Serenity); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Shalkina Elena")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_91"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0091-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0279")]), _vm._v(" "), _c('strong', [_vm._v("Aries: Character from Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Sarah Michell Ewell, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" M-Squared Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0091-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0280")]), _vm._v(" "), _c('strong', [_vm._v("Yoruichi: Character from BLEACH")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Mike Kowalek, eleventhphotograph, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR/MODEL:")]), _vm._v(" Megan Leduc; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" eleventhphotograph")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_92"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0092-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0281")]), _vm._v(" "), _c('strong', [_vm._v("Gunji: Character from Togainu no Chi")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Evgeniy Machihin (Indie), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Belaya Sova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Aleksandra Kaminskaya (Akami)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0092-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0282")]), _vm._v(" "), _c('strong', [_vm._v("Reiji Miyabi: Character from Star Driver")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Evgeniy Machihin (Indie), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Kletochka; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Aleksandra Kaminskay (Akami)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0092-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0283")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko “Alice” Shionji: Character from Kamisama Memo-chou")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jene Kirishima")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0092-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0284")]), _vm._v(" "), _c('strong', [_vm._v("Hitagi Senjougahara: Character from Bakemonogatari")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Dhenz Villaflor")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_93"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0093-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0285")]), _vm._v(" "), _c('strong', [_vm._v("Shirakiin Ririchiyo: Character from Inu X Boku SS")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Angel Ayanami, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kira Hokuten")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0093-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0286")]), _vm._v(" "), _c('strong', [_vm._v("Sieglinde: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Voroninskaya, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Irina Zlobina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0093-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0287")]), _vm._v(" "), _c('strong', [_vm._v("Yui Hirasawa: Character from K-On")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christine Choi (AoiMizuno), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Sojians")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0093-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0288")]), _vm._v(" "), _c('strong', [_vm._v("Chrome Dokuro: Character from Hitman Reborn")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kurai Hisaki, Cosmeko, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kevin Gravel")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_94"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0094-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0289")]), _vm._v(" "), _c('strong', [_vm._v("Hinoto: Character from X")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Heather Holdren, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Falling Feathers")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0094-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0290")]), _vm._v(" "), _c('strong', [_vm._v("Magic Girl: Character from Nardack Butterfly Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ferny Andrade, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo Gomez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0094-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0291")]), _vm._v(" "), _c('strong', [_vm._v("Mio Akiyama: Character from K-On")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Larchenko Veronika (Lady Integra), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kseniya Luchkova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0094-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0292")]), _vm._v(" "), _c('strong', [_vm._v("Rosiel: Character from Angel Sanctuary")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Katherine Tulina, Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kseniya Luchkova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_95"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0095-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0293")]), _vm._v(" "), _c('strong', [_vm._v("Sailor Pluto: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Maria Kozhanova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0095-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0294")]), _vm._v(" "), _c('strong', [_vm._v("Korra: Character from Legend of Korra")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tania C (Wisecraxx), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Mindfall Media")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0095-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0295")]), _vm._v(" "), _c('strong', [_vm._v("Chii: Character from Chobits")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Megami Shiawase, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_96"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0096-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0296")]), _vm._v(" "), _c('strong', [_vm._v("Alice: Character from Scissors Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Quetzali Pelayo (Ketzy), Ketzy Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ali Hernandez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0096-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0297")]), _vm._v(" "), _c('strong', [_vm._v("Radu Barvon and Ion Fortuna: Characters from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Tsyplenkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Maria Avdonyushkina and Anna Tsyplenkova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Maria Avdonyushkina and Anna Tsyplenkova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taisia Flyagina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0096-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0298")]), _vm._v(" "), _c('strong', [_vm._v("Radu Barvon: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Tsyplenkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Maria Avdonyushkina and Anna Tsyplenkova; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Maria Avdonyushkina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taisia Flyagina (Tis)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0096-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0299")]), _vm._v(" "), _c('strong', [_vm._v("Tsugiri: Character from Alichiro")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Tsyplenkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Olga Mazurova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0096-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0300")]), _vm._v(" "), _c('strong', [_vm._v("Clause Haine: Character from Scissors Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Francisco Pelayo (NeonLights), Neon Lights Cosplay, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ali Hernandez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_97"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0097-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0301")]), _vm._v(" "), _c('strong', [_vm._v("Salamandre and Lia de Beaumont: Characters from Le Chevalier D’eon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Claudia Franz, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Claudia Franz and Ronald Wolf; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Claudia Franz and Ronald Wolf; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andreas Zimmer")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0097-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0302")]), _vm._v(" "), _c('strong', [_vm._v("Lia de Beaumont: Character from Le Chevalier D’eon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Claudia Franz, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Claudia Franz and Ronald Wolf; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Claudia Franz; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Andreas Zimmer")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0097-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0303")]), _vm._v(" "), _c('strong', [_vm._v("Salamandre: Character from Le Chevalier D’eon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ronald Wolf, Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kashikosa")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_98"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0304")]), _vm._v(" "), _c('strong', [_vm._v("Maka Albarn: Character from Soul Eater")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Arras M. Wiedorn, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Morgan Harris")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0305")]), _vm._v(" "), _c('strong', [_vm._v("Sailor Venus: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kristen Morici (KoriStarFire), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" StillVisions")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0306")]), _vm._v(" "), _c('strong', [_vm._v("Mari Illustrious Makinami: Character from Evangelion: 2.0 You Can (Not) Advance")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anastasia Glushkova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Mikhail Girshovich")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0307")]), _vm._v(" "), _c('strong', [_vm._v("Sailor Jupitor: Character from Sailor Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Rey “Ekusukariba Bird”, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Laura; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Ana Rey “Ekusukariba Bird”; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verónica Santos (Dream Station)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0308")]), _vm._v(" "), _c('strong', [_vm._v("Officer Jenny: Character from Pokémon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Heather McAffee (The Only Angel), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Holly Hill")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0309")]), _vm._v(" "), _c('strong', [_vm._v("Monkey D. Luffy: Character from One Piece")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anna Celuyko (Pixie), Panda Banda, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_99"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0099-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0310")]), _vm._v(" "), _c('strong', [_vm._v("Mukuro Rokudo: Character from Katekyo Hitman Reborn")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tina Pham, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Tina Pham and Isabella Wu; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Martin Huang")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0099-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0311")]), _vm._v(" "), _c('strong', [_vm._v("Nyaruko: Character from Haiyore! Nyaruko-san")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Pamela Torres, Nazgwen Cosplay, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Teresa Macías; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verónica Santos (Dream Station)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0099-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0312")]), _vm._v(" "), _c('strong', [_vm._v("Bulma Briefs: Character from Dragonball Motorcycle Version")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Virgina Panilla Valera, Spain; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jose Manchado")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_100"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0100-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0313")]), _vm._v(" "), _c('strong', [_vm._v("Arashi: Character from X1999")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Riko Kojima, Malaysia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Raz Hoe")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0100-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0314")]), _vm._v(" "), _c('strong', [_vm._v("Phoenix Sui-O: Character from Pet Shop of Horrors")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Yuliana Stepanova (Ptishon), Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Katja Burtyanski (Green Makakas)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0100-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0315")]), _vm._v(" "), _c('strong', [_vm._v("Her Little Ladyship: Character from Bizenghast")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" M. Alice LeGrow, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Dorian Bachmann")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0100-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0316")]), _vm._v(" "), _c('strong', [_vm._v("Elizabeth Bathory: Character from Horror Collector")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Maria Avdonyushkina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexanov Alexey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_101"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0101-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0317")]), _vm._v(" "), _c('strong', [_vm._v("Mirka Fortuna: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Yuliana Stepanova (Ptishon), Germany; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alena Kucheruk (Pugoffka)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0101-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0318")]), _vm._v(" "), _c('strong', [_vm._v("Beatrice: Character from When They Cry")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kochanova Elena (Lina Alucard), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Lantsuzskaya Irina, Kochanova Lyudmila, and Kochanova Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Kochanova Elena (Lina Alucard); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taras Buteiko")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_102"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0102-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0319")]), _vm._v(" "), _c('strong', [_vm._v("Princess of the Crystal: Character from Mawaru Penguindrum")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Rey “Ekusukariba Bird”, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Sara Kei; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Ana Rey “Ekusukariba Bird”; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verónica Santos (Dream Station)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0102-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0320")]), _vm._v(" "), _c('strong', [_vm._v("Anarchy Panty and Stocking: Characters from Panty & Stocking with Garterbelt")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Andrea Stames, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Andrea Stames and Rachel DeGroff; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODELS:")]), _vm._v(" Andrea Stames and Rachel DeGroff; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Tony Trinh")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0102-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0321")]), _vm._v(" "), _c('strong', [_vm._v("Ichihara Yuuko: Character from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Andrea Stames, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Tony Trinh")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0102-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0322")]), _vm._v(" "), _c('strong', [_vm._v("Ran Shuuei: Character from Saiunkoku Monogatari")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ilina Daria, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_103"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0103-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0323")]), _vm._v(" "), _c('strong', [_vm._v("Lunatic (Yuri Petrov): Character from Tiger & Bunny")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tania C (Wisecraxx), USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Gackto")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0103-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0324")]), _vm._v(" "), _c('strong', [_vm._v("Jack Vessalius: Character from Pandora Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Rubabkova Veronika (Kazuki Fuchouin), Belarusian State Music Theater; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alena Moreva (cxalena)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0103-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0325")]), _vm._v(" "), _c('strong', [_vm._v("Kirakishou: Character from Rozen Maiden")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Heather Holdren, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Falling")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0103-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0326")]), _vm._v(" "), _c('strong', [_vm._v("Myobi: Character from Alichino")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Maria Avdonyushkina, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alexanov Alexey")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_104"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0104-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0327")]), _vm._v(" "), _c('strong', [_vm._v("Kirara: Character from Kore Wa Zombie Desu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Melanie Joanne, Singapore; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Darryl Chionh")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0104-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0328")]), _vm._v(" "), _c('strong', [_vm._v("Monica Argento: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Noycosplay, Italy; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Luca Albrigok")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0104-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0329")]), _vm._v(" "), _c('strong', [_vm._v("Ranma Saotome: Character from Ranma "), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Stephanie Beaulieu, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Droo")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0104-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0330")]), _vm._v(" "), _c('strong', [_vm._v("Mio Akiyama: Character on K-On")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Lerchenko Veronika (Lady Integra), Belarus; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kseniya Luchkova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0104-05.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0331")]), _vm._v(" "), _c('strong', [_vm._v("Kurai: Character from Angel Sanctuary")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anteris Burgos, Dominican Republic; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Nicole Alú")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0104-06.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0332")]), _vm._v(" "), _c('strong', [_vm._v("Arakune: Character from Angel Sanctuary")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Soboleva Elena, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Svetlana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Soboleva Elena; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Misaki Sai")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_105"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0105-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0333")]), _vm._v(" "), _c('strong', [_vm._v("Sebastian Michaelis: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ilina Daria, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_106"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0106-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0334")]), _vm._v(" "), _c('strong', [_vm._v("Amira Halgal: Character from A Bride’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Carol Ann Voltarel, Athena’s Wink, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ann Voltarel")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0106-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0335")]), _vm._v(" "), _c('strong', [_vm._v("Asuna Yuuki: Character from Sword Art Online")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kris Lacson, Phillippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Red Abuel")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0106-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0336")]), _vm._v(" "), _c('strong', [_vm._v("Cheshire Cat: Character from Scissors Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Johnny Smith")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_107"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0107-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0337")]), _vm._v(" "), _c('strong', [_vm._v("Kaoru Kamiya and Rurouni Kenshin: Characters from Rurouni Kenshin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Gingi Edmonds, Retrospective Imagery, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS/MODELS:")]), _vm._v(" Gingi Edmonds and Jonathan Freeman; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Retrospective Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0107-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0338")]), _vm._v(" "), _c('strong', [_vm._v("Mei Misaki: Character from Another")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Mary Cua; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0107-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0339")]), _vm._v(" "), _c('strong', [_vm._v("Boris Airay: Character from Alice in the Country of Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Janova Anna (Nikoli), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Rem")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_108"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0108-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0340")]), _vm._v(" "), _c('strong', [_vm._v("Abel Nightroad: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Kupurina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_109"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0341")]), _vm._v(" "), _c('strong', [_vm._v("Amaru Ryudo: Character from Sohryuden")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Eliot, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Lorenzo Gomez")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0342")]), _vm._v(" "), _c('strong', [_vm._v("Esther Blanchett: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Anette Bittner (Tazzie), Hungary; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Csaba Födémesi")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0343")]), _vm._v(" "), _c('strong', [_vm._v("Myobi: Character from Alichino")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" SnowFall Slasher, Philippines; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" SnowFall Slasher, Solenumira Concepcion, and Ma Len Gases; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Aeade Alastair Alexander and Zell de Belen")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0344")]), _vm._v(" "), _c('strong', [_vm._v("Lady Ciel Phantomhive: Character from Black Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Galinovskaya Anastasia (Kuroru), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Zakharova Ekaterina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0345")]), _vm._v(" "), _c('strong', [_vm._v("Jane Judith Jocelyn: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Voroninskaya, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Oleg Kugaev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0346")]), _vm._v(" "), _c('strong', [_vm._v("Jane Judith Jocelyn: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Voroninskaya, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Oleg Kugaev")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_110"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0110-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0347")]), _vm._v(" "), _c('strong', [_vm._v("Ichigo Kurosaki: Character from BLEACH")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tina Lam, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Tina Lam; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tina Lam; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Judith Stevens")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0110-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0348")]), _vm._v(" "), _c('strong', [_vm._v("Euphemia Li Brittania: Character from Code Geass")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kari Klyne, North Pacific Cosplay, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Eurobeat Kasumi Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0110-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0349")]), _vm._v(" "), _c('strong', [_vm._v("Homura Akemi: Character from Puella Magi Madoka Magica")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Vickybunnyangel, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jack Liu")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0110-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0350")]), _vm._v(" "), _c('strong', [_vm._v("Gilbert Nightray: Character from Pandora Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Martin Chella, Australia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Antonius Cherdy")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_111"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0111-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0351")]), _vm._v(" "), _c('strong', [_vm._v("Female trainer: Character from Pokémon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Carrie Wink, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Carol Ann Voltarel")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0111-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0352")]), _vm._v(" "), _c('strong', [_vm._v("Scarf-tan/Scarf Girl: Character from Tiger & Bunny")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tiffany Lim, Manila; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Mary Cua; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Tiffany Lim; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Peppy Salita")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0111-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0353")]), _vm._v(" "), _c('strong', [_vm._v("Ness: Character from Fractale")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Elena Samoylova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ekaterina Kruchinina")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0111-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0354")]), _vm._v(" "), _c('strong', [_vm._v("Robin Sena: Character from Witch Hunter Robin")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Leigh A. Alexander, The Prancing Unicorn, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Jlinto")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0111-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0355")]), _vm._v(" "), _c('strong', [_vm._v("Eda: Character from Black Lagoon")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tanuki Tinka Asai, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Daria")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0111-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0356")]), _vm._v(" "), _c('strong', [_vm._v("Larva: Character from Vampire Princess Miyu")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Kari Klyne, North Pacific Cosplay, Canada; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Julie Townsend")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_112"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0112-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0357")]), _vm._v(" "), _c('strong', [_vm._v("Itachi Uchiha: Character from Naruto Shippuden")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Brittany Hope, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Ger Tysk")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0112-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0358")]), _vm._v(" "), _c('strong', [_vm._v("Killer Bee: Character from Naruto")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Paul Kulowitch, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Larry Irwin Hullum, Jr.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0112-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0359")]), _vm._v(" "), _c('strong', [_vm._v("Syaoran Li: Character from Tsubasa Reservoir Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatyana Varshitskaya (Sorano Suzu), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Envy_the_One")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_113"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0113-01.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0360")]), _vm._v(" "), _c('strong', [_vm._v("Robotech Cyclone Ride Armor: Character from Robotech")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Chris Lee, USA")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land70"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0113-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0361")]), _vm._v(" "), _c('strong', [_vm._v("Briareos Hecatonchires: Character from Appleseed Ex Machina")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Jimmy Burns, Angry Dog Studios, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Martin Wong")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_114"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0114-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0362")]), _vm._v(" "), _c('strong', [_vm._v("Will of the Abyss: Character from Pandora Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Yurlova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Natalia Yurlova and Matveeva Galina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Velery Kaptseva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0114-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0363")]), _vm._v(" "), _c('strong', [_vm._v("Urahara Kisuke: Character from BLEACH")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Natalia Yurlova, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Natalia Yurlova and Matveeva Galina; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Velery Kaptseva")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land60"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0114-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0364")]), _vm._v(" "), _c('strong', [_vm._v("Takenaka Hanbei: Character from Sengoku Basara 2")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Christina Chilingaryan (Iscariot_Elian), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Elena Vopiyakova (Shiki); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Christina Chilingaryan (Iscariot_Elian); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Taisia Flyagina (Tis)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_115"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0115-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0365")]), _vm._v(" "), _c('strong', [_vm._v("Lilith Sahl: Character from Trinity Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tatiana Garms, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Angelina Goncharova (Ashitaro)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_116"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0116-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0366")]), _vm._v(" "), _c('strong', [_vm._v("Adiane the Elegant: Character from Gurren Lagann")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Darya Pasechnyk, Ukraine; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Yurii Vashkulat (Nekudza)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0116-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0367")]), _vm._v(" "), _c('strong', [_vm._v("Maxima Elfield: Character from Shining Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Belyaeva Elena (Serenity), Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Tatiana; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Belyaeva Elena (Serenity); "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Alyona Arnautova")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0116-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0368")]), _vm._v(" "), _c('strong', [_vm._v("Re-L Mayer: Character from Ergo Proxy")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Tanuki Tinka Asai, Russia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" N†kon")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_117"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0117-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0369")]), _vm._v(" "), _c('strong', [_vm._v("Marik Ishtar: Character from Yu-Gi-Oh!")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Micho Teh, Malaysia; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATORS:")]), _vm._v(" Shine Ng, Mushroom Yit Ying, and Micho Teh; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Shine Ng; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Micho Teh")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0117-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0370")]), _vm._v(" "), _c('strong', [_vm._v("Queen Chrysalis: Character from My Little Pony: Friendship is Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Haley Holmes, HNH Beauty, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Greg Edwards")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0117-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0371")]), _vm._v(" "), _c('strong', [_vm._v("Dead Master: Character from Black Rock Shooter")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Ana Rey “Ekusukariba Bird”, Mexico; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FABRICATOR:")]), _vm._v(" Laura; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MODEL:")]), _vm._v(" Ana Rey “Ekusukariba Bird”; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Verónica Santos (Dream Station)")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_118"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0118-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0372")]), _vm._v(" "), _c('strong', [_vm._v("Oruha: Character from Clover")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Yaya Han, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Geoffrey Nicholson")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land80"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0119-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0373")]), _vm._v(" "), _c('strong', [_vm._v("Yuuko: Character from xxxHolic")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Yaya Han, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Paul Tien")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0119-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0374")]), _vm._v(" "), _c('strong', [_vm._v("Carmilla: Character from Vampire Hunter D")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Yaya Han, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Brian Boling")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0119-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("0375")]), _vm._v(" "), _c('strong', [_vm._v("Sheryl Nome: Character from Macross Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTOR:")]), _vm._v(" Yaya Han, USA; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO:")]), _vm._v(" Shea Standefer")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0